import { ShipmentDeviationType, ShipmentTransitTime, WaybillIdView } from '../../../models';
import { TransportMode } from '../../../../common/constants/transport-mode';
import { WaybillMapStop } from '../../../../common/models/map-tracking-points.model';
import { FormBuilder, FormControl } from '@angular/forms';

export class ShipmentWaybillOverview {
  carriageConditionCodes: string[];
  carriers: string[];
  commercialInvoiceNumbers: string[];
  deliveryNoteNumbers: string[];
  idView: WaybillIdView;
  transitTime: ShipmentTransitTime;
  incoterms: string;
  cancelled: boolean;
  purchaseOrderNumbers: string[];
  reference: string;
  serviceRequirementCodes: TransportMode[];
  shipmentCreated: number;
  transportServicePriorityCode: string;
  inboundDeliveryNoteNumbers: string[];
  deviationStatus: ShipmentDeviationType;
  vesselName: string | null;
  flightNumber: string | null;
}

export class ShipmentWaybillEditForm {
  constructor(
    model: ShipmentWaybillOverview,
    fb: FormBuilder = new FormBuilder(),
    public deliveryNotes: FormControl<string[]> = fb.control<string[]>(model.deliveryNoteNumbers, []),
    public invoices: FormControl<string[]> = fb.control<string[]>(model.commercialInvoiceNumbers, []),
    public purchaseOrders: FormControl<string[]> = fb.control<string[]>(model.purchaseOrderNumbers, []),
  ) {}
}

export class ShipmentWaybillEdit {
  deliveryNotes?: string[];
  invoices?: string[];
  purchaseOrders?: string[];
}

export class ShipmentWaybillMapData {
  gpsPoints: WaybillMapStop[];
  transportMode: TransportMode;
}
